<div class="balance">
  <div class="balance__info" [routerLink]="['/', lang.current, 'account', 'balance']">
    @if (launcher.balance$ | async; as balance) {
      <div class="balance__value">
        {{ balance?.amount | currencyFormat:user.currentCurrency?.currency }}
      </div>
    } @else {
      <div class="balance__value">
        {{ user.currentCurrency?.amount | currencyFormat:user.currentCurrency?.currency }}
      </div>
    }
    <div class="balance__currency">
      @if (user.currentCurrency?.isCrypto) {
        <div class="--crypto">
          <span>{{ user?.currentCurrency.currency }}</span>
          <img [src]="'/assets/svg/crypto-symbols/' + (user.currentCurrency?.currency | lowercase) + '.svg'" alt="">
        </div>
      } @else {
        <div class="--fiat">
          {{ user.currentCurrency?.currency }}
          <span>{{ user.currentCurrency?.symbol }}</span>
        </div>
      }
    </div>
  </div>
  <div class="balance__icon text-gradient" [routerLink]="['/', lang.current, 'account', 'balance']">
    <i class="icon-wallet"></i>
  </div>
  <button
    [routerLink]="['/', lang.current, 'account', 'deposit']"
    [ngClass]="{
    'animate': user?.currentCurrency?.amount === 0
    }"
    class="btn small gradient-filled">
    {{ 'btn.deposit' | translate }}
  </button>
</div>
